/* -------------------------------------------------------------------------- */
/*                                Panel styles                */
/* -------------------------------------------------------------------------- */

@import './bq-panel.variables';

:host {
  @apply block;
}

.bq-panel {
  @include animation-fade-in;
  @apply fixed z-[--bq-panel-z-index] overflow-y-auto overflow-x-hidden is-[--bq-panel--width] max-bs-[--bq-panel--height];
  @apply rounded-[--bq-panel--border-radius] bg-[--bq-panel--background] shadow-[shadow:--bq-panel--box-shadow];
  @apply pe-[--bq-panel--padding-end] ps-[--bq-panel--padding-start] p-b-[--bq-panel--paddingY];
  @apply border-[length:--bq-panel--border-width] border-[color:--bq-panel--border-color];

  border-style: var(--bq-panel--border-style);
}
